<template>
  <bg-style class="text-widget" :class="{ 'is-mobile': $store.getters.isMobile }" :bg="model.background" :mobile-bg="model.mobileBackground">
    <module-block :max-content-width="1280">
      <rich-text v-model="model.text" :visible="model.titleVisible" :stroke.sync="model.titleStroke" :editing="editing" class="text-box" />
    </module-block>
  </bg-style>
</template>

<script>
import RichText from "~/components/richText/index.vue"
import ModuleBlock from '~/components/common/ModuleBlock.vue'


export default {
  name: "TextWidget",
  components: {
    ModuleBlock,
    RichText
  },
  props: {
    editing: {
      type: Boolean,
      default: false
    },
    model: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
    }
  },
  created() {
    //
  }
}
</script>

<style scoped lang="less">
.text-widget {
  padding: 20px 0;
  &.is-mobile {
    padding: 10px;
    .text-box {
      padding: 0 11px;
    }
  }
}
</style>
